// H5 support module routes.
import type { RouteRecordRaw } from "vue-router";

export const supportRoutes: RouteRecordRaw[] = [
  {
    path: "/support",
    name: "support",
    component: () => import("@/modules/support/pages/SupportPage.vue"),
  },
  {
    path: "/conversations",
    name: "conversations",
    component: () => import("@/modules/support/pages/ConversationsPage.vue"),
  },
  {
    path: "/conversations/:id",
    name: "conversation",
    component: () => import("@/modules/support/pages/ConversationPage.vue"),
  },
  {
    // External contact methods remain available as a fallback.
    path: "/concierge",
    name: "concierge",
    component: () => import("@/modules/support/pages/ConciergePage.vue"),
  },
];
